import { CMSService, type Content } from '@/services/isomorphic/ContentService';
import { type FC } from 'react';

import { exhaustiveGuard } from '@/utils/function-utils';
import { BuilderRender } from './BuilderRender';

export interface IContentProps {
  /**
   * Content to render.
   */
  content: Content;
  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * A component that abstracts over content rendering. It takes in content and renders
 * it as is.
 */
export const RenderContent: FC<IContentProps> = ({
  content,
  handleLinkClick
}) => {
  const { service } = content;
  switch (service) {
    case CMSService.Builder:
      return (
        (content.data || content.dataModel) && (
          <BuilderRender handleLinkClick={handleLinkClick} content={content} />
        )
      );
    default:
      return exhaustiveGuard(service, `Unknown content service: ${service}`);
  }
};

export default RenderContent;
